'use strict';
module.exports = [
	function () {

		return {
			controller: ['$scope', yModelTypeSelectCtrl],
			controllerAs: 'ctrl',
			template: `
				<model-type-select
					original-id="original_id"
					rm-model="model_id"
					rm-change="ctrl.onUpdate(model_id)"
					model-types="rmRawFields"
					ng-if="!rmReadOnly"
					label="{{ rmLabel }}"
					disabled="rmDisabled"
				></model-type-select>
			`,
			scope: {
				yModel: '=',
				model_id: '=localModelTypeId',
				rmRawFields: '=',
				rmLabel: '@',
				rmDisabled: '=',
				rmReadOnly: '='
			},
			restrict: 'E',
			link: function ($scope, $element) {
			},
		};
	}];

class yModelTypeSelectCtrl {
	constructor($scope) {
		this.$scope = $scope;

		this.yObserveHandler = this.yObserver.bind(this);
		$scope.yModel.observe(this.yObserveHandler);
		$scope.$on('$destroy', this.destroy.bind(this));

		$scope.original_id = $scope.yModel.get('model_type_id');
		$scope.model_id = $scope.original_id;


		//TEST TEST TEST
		window.test = $scope.yModel;
	}

	yObserver(event) {
		const {$scope} = this;
		if (event.keysChanged.has('model_type_id')) {
			$scope.$evalAsync(() => $scope.model_id = $scope.yModel.get('model_type_id'));
		}
	}

	onUpdate(newModelId) {
		let yId = this.$scope.yModel.get('model_type_id');
		if (newModelId !== yId) {
			let modelTypeObj;

			this.$scope.rmRawFields.forEach((modelType) => {
				if (newModelId === modelType.id) {
					modelTypeObj = modelType;
				}
			});

			// Update id when model type has been found
			if (modelTypeObj == null) return;
			this.$scope.yModel.set('model_type_id', newModelId);
		}
	}

	destroy() {
		this.$scope.yModel.unobserve(this.yObserveHandler);
	}
}
